import React, {Component} from 'react'

// Import Scss
import './StatusBar.scss'

// Import Image
import close from '../../images/close-white.png'

class StatusBar extends Component {

  componentWillUnmount() {
    this.props.resetStateStatusBar()
  }

  render() {
    return (
      <div className="candidates__notify_wrap">
        {
          this.props.statusBarContent.map((item, key) => (
            <div key={key} className={"candidates__notify text-center"}>
              <p>{item}</p>
              <button className="candidates__btn__notify-close" onClick={() => {
                this.props.toggleStatusBar(item)
              }}>
                <img src={close} alt="btn-notify__close"/>
              </button>
            </div>
          ))
        }
      </div>
    )
  }
}

export default StatusBar



// WEBPACK FOOTER //
// ./src/components/StatusBar/StatusBar.js